/**
 * Raw event emitted when a user enters checkout for a product
 */

export enum RbcCheckoutRawEventName {
  ViewedFlightCheckout = "ViewedFlightCheckout",
  ViewedCarCheckout = "ViewedCarCheckout",
  ViewedHotelCheckout = "ViewedHotelCheckout",
  ViewedPackageCheckout = "ViewedPackageCheckout",
  ViewedActivitiesCheckout = "ViewedActivitiesCheckout",
}

export interface ViewedFlightCheckoutRawEvent {
  name: RbcCheckoutRawEventName.ViewedFlightCheckout;
  properties?: {
    rbc_price_tab?: "fixed" | "flex";
  };
}

export interface ViewedCarCheckoutRawEvent {
  name: RbcCheckoutRawEventName.ViewedCarCheckout;
}

export interface ViewedHotelCheckoutRawEvent {
  name: RbcCheckoutRawEventName.ViewedHotelCheckout;
}

export interface ViewedPackageCheckoutRawEvent {
  name: RbcCheckoutRawEventName.ViewedPackageCheckout;
}

export interface ViewedActivitiesCheckoutRawEvent {
  name: RbcCheckoutRawEventName.ViewedActivitiesCheckout;
}

export type ViewedCheckoutRawEvent =
  | ViewedFlightCheckoutRawEvent
  | ViewedCarCheckoutRawEvent
  | ViewedHotelCheckoutRawEvent
  | ViewedPackageCheckoutRawEvent
  | ViewedActivitiesCheckoutRawEvent;
